var textCropConfig = {
    topCrop: 5.5,
    bottomCrop: 6.5,
};

export { textCropConfig };
//# sourceMappingURL=textCropConfig.js.map
